import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Calendar, Clock, ArrowRight, Search } from 'lucide-react'
import { blogPosts, blogCategories } from '../data/blogPosts'

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü')
  const [searchTerm, setSearchTerm] = useState('')

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'Tümü' || post.category === selectedCategory
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
    return matchesCategory && matchesSearch
  })

  return (
    <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="1:1" data-component-id="client/src/pages/BlogPage.jsx:1:1" className="min-h-screen">
      <section data-component-path="client/src/pages/BlogPage.jsx" data-component-line="2:2" data-component-id="client/src/pages/BlogPage.jsx:2:2" 
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1600&q=80)'
        }}
      >
        <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="3:3" data-component-id="client/src/pages/BlogPage.jsx:3:3" className="absolute inset-0 bg-blue-900/70"></div>
        <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="4:4" data-component-id="client/src/pages/BlogPage.jsx:4:4" className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 data-component-path="client/src/pages/BlogPage.jsx" data-component-line="5:5" data-component-id="client/src/pages/BlogPage.jsx:5:5" className="text-5xl font-bold mb-4">Ambalaj Dünyası Blog</h1>
          <p data-component-path="client/src/pages/BlogPage.jsx" data-component-line="6:6" data-component-id="client/src/pages/BlogPage.jsx:6:6" className="text-xl">Sektörel bilgiler, teknik rehberler ve yenilikler</p>
        </div>
      </section>

      <section data-component-path="client/src/pages/BlogPage.jsx" data-component-line="7:7" data-component-id="client/src/pages/BlogPage.jsx:7:7" className="py-12 bg-white">
        <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="8:8" data-component-id="client/src/pages/BlogPage.jsx:8:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="9:9" data-component-id="client/src/pages/BlogPage.jsx:9:9" className="mb-8">
            <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="10:10" data-component-id="client/src/pages/BlogPage.jsx:10:10" className="relative mb-6">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input data-component-path="client/src/pages/BlogPage.jsx" data-component-line="11:11" data-component-id="client/src/pages/BlogPage.jsx:11:11"
                type="text"
                placeholder="Blog yazılarında ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="12:12" data-component-id="client/src/pages/BlogPage.jsx:12:12" className="flex flex-wrap gap-3">
              {blogCategories.map((category) => (
                <button data-component-path="client/src/pages/BlogPage.jsx" data-component-line="13:13" data-component-id="client/src/pages/BlogPage.jsx:13:13"
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    selectedCategory === category
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="14:14" data-component-id="client/src/pages/BlogPage.jsx:14:14" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <Link data-component-path="client/src/pages/BlogPage.jsx" data-component-line="15:15" data-component-id="client/src/pages/BlogPage.jsx:15:15"
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="16:16" data-component-id="client/src/pages/BlogPage.jsx:16:16" className="relative h-48 overflow-hidden">
                  <img data-component-path="client/src/pages/BlogPage.jsx" data-component-line="17:17" data-component-id="client/src/pages/BlogPage.jsx:17:17"
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    onError={(e) => {
                      e.target.onerror = null
                      e.target.src = 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80'
                    }}
                  />
                  <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="18:18" data-component-id="client/src/pages/BlogPage.jsx:18:18" className="absolute top-4 left-4">
                    <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="19:19" data-component-id="client/src/pages/BlogPage.jsx:19:19" className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>

                <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="20:20" data-component-id="client/src/pages/BlogPage.jsx:20:20" className="p-6">
                  <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="21:21" data-component-id="client/src/pages/BlogPage.jsx:21:21" className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="22:22" data-component-id="client/src/pages/BlogPage.jsx:22:22" className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="23:23" data-component-id="client/src/pages/BlogPage.jsx:23:23">{post.date}</span>
                    </div>
                    <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="24:24" data-component-id="client/src/pages/BlogPage.jsx:24:24" className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="25:25" data-component-id="client/src/pages/BlogPage.jsx:25:25">{post.readTime}</span>
                    </div>
                  </div>

                  <h3 data-component-path="client/src/pages/BlogPage.jsx" data-component-line="26:26" data-component-id="client/src/pages/BlogPage.jsx:26:26" className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                    {post.title}
                  </h3>

                  <p data-component-path="client/src/pages/BlogPage.jsx" data-component-line="27:27" data-component-id="client/src/pages/BlogPage.jsx:27:27" className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>

                  <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="28:28" data-component-id="client/src/pages/BlogPage.jsx:28:28" className="flex items-center gap-2 text-blue-600 font-medium group-hover:gap-3 transition-all">
                    Devamını Oku
                    <ArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="29:29" data-component-id="client/src/pages/BlogPage.jsx:29:29" className="text-center py-12">
              <p data-component-path="client/src/pages/BlogPage.jsx" data-component-line="30:30" data-component-id="client/src/pages/BlogPage.jsx:30:30" className="text-gray-600 text-lg">
                Aradığınız kriterlere uygun blog yazısı bulunamadı.
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default BlogPage